import React from 'react'
import { Route } from 'react-router-dom'
import { ConnectedSwitch } from 'reactRouterConnected'
import Loadable from 'react-loadable'
import Page from 'components/LayoutComponents/Page'
import NotFoundPage from 'pages/DefaultPages/NotFoundPage'
import HomePage from 'pages/DefaultPages/HomePage'
import PlugAuth from 'lib/PlugAuth'

const loadable = loader =>
  Loadable({
    loader,
    delay: false,
    loading: () => null,
  })

const loadablePrivateRoutes = {
  '/denied': {
    component: loadable(() => import('pages/DefaultPages/DeniedPage'))
  },
  '/cobrancas/lista': {
    component: loadable(() => import('pages/Charges/RepositoryPage'))
  }
}

const loadablePublicRoutes = {
  // Default Pages
  '/login': {
    component: loadable(() => import('pages/Login/LoginPage'))
  },
  '/primeiro-login': {
    component: loadable(() => import('pages/Login/FirstLoginPage'))
  },
  '/alterar-senha': {
    component: loadable(() => import('pages/Login/ChangePasswordPage'))
  },
  '/cadastro': {
    component: loadable(() => import('pages/Company/RegisterPage'))
  },
  '/recuperar-senha': {
    component: loadable(() => import('pages/Login/ForgotPasswordPage'))
  }
}

class Routes extends React.Component {
  timeoutPublicId = null
  timeoutPrivateId = null

  componentDidMount() {
    this.timeoutPublicId = setTimeout(
      () => Object.keys(loadablePublicRoutes).forEach(path => loadablePublicRoutes[path].component.preload()),
      5000, // load after 5 sec
    )
    this.timeoutPrivateId = setTimeout(
      () => Object.keys(loadablePrivateRoutes).forEach(path => loadablePrivateRoutes[path].component.preload()),
      5000, // load after 5 sec
    )
  }

  componentWillUnmount() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId)
    }
  }

  render() {
    return (
      <ConnectedSwitch>
        <PlugAuth exact path="/" component={HomePage} />
        {Object.keys(loadablePublicRoutes).map(path => {
          const { exact, ...props } = loadableRoutes[path]
          props.exact = exact === void 0 || exact || false // set true as default
          return <Route key={path} path={path} {...props} />
        })}
        {Object.keys(loadablePrivateRoutes).map(path => {
          const { exact, ...props } = loadablePrivateRoutes[path]
          props.exact = exact === void 0 || exact || false // set true as default
          return <PlugAuth key={path} path={path} {...props} />
        })}
        <PlugAuth
          render={() => (
            <Page>
              <NotFoundPage />
            </Page>
          )}
        />
      </ConnectedSwitch>
    )
  }
}

const loadableRoutes = {
  ...loadablePublicRoutes,
  ...loadablePrivateRoutes
}

export { loadableRoutes }
export default Routes
